<template>
	<!--FOOTER-->
	<div class="footer">
		<div class="mainbox">
			<div class="footbox">
				<div class="footbox_l wow fadeInUp">
					<div class="footlogo"><img src="@/assets/images/footer/flogo.png" /></div>
					<div class="footcopy">Copyright © 2024 {{ $webTitle }}. {{ t('home.banquansuoyou') }}</div>
					<div class="footlink">
						<a href="javascript:void(0)"><img src="@/assets/images/footer/ins.svg" /></a>
						<a href="javascript:void(0)"><img src="@/assets/images/footer/tg.svg" /></a>
						<a href="javascript:void(0)"><img src="@/assets/images/footer/ytb.svg" /></a>
						<a href="javascript:void(0)"><img src="@/assets/images/footer/fb.svg" /></a>
					</div>
					<div class="footinfo">
						{{ t('home.ranggoupiaogengrongyi') }}
					</div>
				</div>
				<div class="footbox_r wow fadeInUp">
					<div class="footnav">
						<div class="item">
							<div class="t">{{ t('home.guanyu') }}</div>
							<div class="m">
								<ul>
									<li>
										<nuxt-link target="_blank" to="aboutUs">{{ t('home.guanyuwomen') }}</nuxt-link>
									</li>
									<li>
										<a href="javascript:void(0)" @click="handleJumpUrl('contactUs')">{{ t('tipMsg.lianxiwomen') }}</a>
									</li>
									<li>
										<a href="javascript:void(0)" @click="handleJumpUrl('termService')">{{ t('home.tiaokuanyuxize') }}</a>
									</li>
									<li>
										<a href="javascript:void(0)" @click="handleJumpUrl('policyContent')">{{ t('home.yinsizhengce') }}</a>
									</li>
								</ul>
							</div>
						</div>
						<div class="item">
							<div class="t">{{ t('home.fuwu') }}</div>
							<div class="m">
								<ul>
									<li>
										<a href="javascript:void(0)" @click="handleJumpUrl('')">{{ t('login.hangban') }}</a>
									</li>
									<li>
										<a href="javascript:void(0)" @click="handleJumpUrl('help')">{{ t('home.changjianwenti') }}</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="footpay">
						<span>{{ t('home.womenjieshou') }}</span>
						<img src="@/assets/images/footer/visa.svg" />
						<img src="@/assets/images/footer/mastercard.svg" />
						<img src="@/assets/images/footer/paypal.svg" />
						<img src="@/assets/images/footer/alipay.svg" />
					</div>
				</div>
				<div class="clear"></div>
			</div>
		</div>
	</div>
	<!--FOOTER-->
</template>

<script lang="ts" setup>
// import {} from 'vue';
import { useI18n } from 'vue-i18n';
import { routeGo } from '@/hooks/web/jumpGo';
import { useNuxtApp } from 'nuxt/app';
const { $webTitle } = useNuxtApp();
function handleJumpUrl(url: string) {
	routeGo(url);
}
const { t } = useI18n();
</script>

<style lang="scss" scoped></style>
